import { ShortCardTimeReadout } from './ShortCardTimeReadout';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SkeletonThumbnail from '../../../components/TrackCard/Thumbnail/SkeletonThumbnail';
import ThumbnailOverlayed, { CardCompletedMessage } from '../../../components/TrackCard/Thumbnail/ThumbnailOverlayed';
import CardMenuIcon from '../../../features/cardMenu/components/CardMenuIcon';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import { useShort } from '../../shortContent/shortContentQueries';
import { useShortStatus } from '../../shortContent/shortContentHooks';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import { jsx as _jsx } from "react/jsx-runtime";
export const CategoryLabel = styled.div.withConfig({
  displayName: "ShortThumbnailOverlayed__CategoryLabel",
  componentId: "sc-8wdh4h-0"
})(["color:", ";text-transform:capitalize;", ";"], theme.colors.OLAF, ({
  $isGhost
}) => $isGhost ? `opacity: .5` : '');
export const ShortThumbnailOverlayed = ({
  shortId,
  isGhost,
  disableGradient,
  centerContent,
  renderMenu = menu => menu,
  header
}) => {
  const {
    short
  } = useShort(shortId);
  const {
    status
  } = useShortStatus(shortId);
  const completed = status === 'COMPLETED';
  if (!short) {
    return /*#__PURE__*/_jsx(SkeletonThumbnail, {});
  }
  const {
    previewThumbnailRectangleUrl,
    subCategories
  } = short;
  const categories = getDisplayCategories(subCategories) || [];
  return /*#__PURE__*/_jsx(ThumbnailOverlayed, {
    categories: categories,
    completed: completed,
    completedMessage: /*#__PURE__*/_jsx(CardCompletedMessage, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.watched"
      })
    }),
    disableGradient: disableGradient,
    header: header,
    headerIcons: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
      item: {
        id: shortId,
        type: 'SHORT_FORM_CONTENT'
      },
      use: "on-dark"
    })),
    isGhost: isGhost,
    previewThumbnailRectangleUrl: previewThumbnailRectangleUrl || undefined,
    thumbnailCenter: centerContent,
    thumbnailFooter: !completed && /*#__PURE__*/_jsx(ShortCardTimeReadout, {
      shortId: shortId
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'learningCenter.shortCard.label'
    })
  });
};
export default ShortThumbnailOverlayed;